/**
 * 报废管理枚举
 */

// 是否(1-2)（1.是、2.否）
export enum NumYesOrNo {
  /**
   * 是
   */
  YES = 1,
  /**
   * 否
   */
  NO = 2
}
export enum NumYesOrNoName {
  YES = '是',
  NO = '否'
}

// 是否(1-20)（1.是、0.否）
export enum OneYesZeroNo {
  /**
   * 是
   */
  YES = 1,
  /**
   * 否
   */
  NO = 0
}
export enum OneYesZeroNoName {
  YES = '是',
  NO = '否'
}

// 报废单tab页； （报废通知单； 报废单； 报废商品池）
export enum ETabsActiveKeyType {
  /**
   * 报废通知单
   */
  NOTICE = 'NOTICE',
  /**
   * 报废单
   */
  ORDER = 'ORDER',
  /**
   * 报废商品池
   */
  POOL = 'POOL'
}


// 操作类型(1-单个操作 2-提交并审批)
export enum OperationType {
  /**
   * 单个操作
   */
  SINGLE_OPERATION = 1,
  /**
   * 提交并审批
   */
  SUBMIT_AND_APPROVE = 2
}

// 通知单-----------------------------------------------------------
// 审批状态（3.已通过、4.已拒绝）
export enum ApprovalStatusEnum {
  /**
   * 已通过
   */
  APPROVED = 3,
  /**
   * 已拒绝
   */
  REJECTED = 4
}
export enum ApprovalStatusEnumName {
  APPROVED = '已通过',
  REJECTED = '已拒绝'
}

// 报废单单据状态（1.草稿、2.已下发、3.报废中、4.已完成、5.已取消）
export enum BillStatus {
  /**
   * 草稿
   */
  DRAFT = 1,
  /**
   * 已下发
   */
  ISSUED = 2,
  /**
   * 报废中
   */
  SCRAPPING = 3,
  /**
   * 已完成
   */
  COMPLETED = 4,
  /**
   * 已取消
   */
  CANCELLED = 5
}
export enum BillStatusName {
  DRAFT = '草稿',
  ISSUED = '已下发',
  SCRAPPING = '报废中',
  COMPLETED = '已完成',
  CANCELLED = '已取消'
}

// 是否展示功能键（1：是、2:否）
export enum IfShow {
  /**
   * 是
   */
  YES = 1,
  /**
   * 否
   */
  NO = 2
}
export enum IfShowName {
  YES = '是',
  NO = '否'
}

// 执行状态（1.未回执、2.部分回执、3.全部回执）
export enum ExecutionStatus {
  /**
   * 未回执
   */
  NOT_RECEIPT = 1,
  /**
   * 部分回执
   */
  PARTIAL_RECEIPT = 2,
  /**
   * 全部回执
   */
  ALL_RECEIPT = 3
}
export enum ExecutionStatusName {
  NOT_RECEIPT = '未回执',
  PARTIAL_RECEIPT = '部分回执',
  ALL_RECEIPT = '全部回执'
}

// 操作类型（1:新增、2:删除、3:修改)
export enum OperationType {
  /**
   * 新增
   */
  ADD = 1,
  /**
   * 删除
   */
  DELETE = 2,
  /**
   * 修改
   */
  UPDATE = 3
}
export enum OperationTypeName {
  ADD = '新增',
  DELETE = '删除',
  UPDATE = '修改'
}


// 报废单-----------------------------------------------------------
//报废单状态（1. 草稿、2. 审批中、3. 已审批）
export enum ScrapStatus {
  /**
   * 草稿
   */
  DRAFT = 1,
  /**
   * 审批中
   */
  APPROVING = 2,
  /**
   * 已审批
   */
  APPROVED = 3
}
export enum ScrapStatusName {
  DRAFT = '草稿',
  APPROVING = '审批中',
  APPROVED = '已审批'
}